import { t } from "i18next";
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Feedback = () => {
  const initialForm = {
    full_name: "",
    phone_number: "",
    reception: "",
    room_cleanliness: "",
    food_quality: "",
    staff_behavior: "",
    quality_service: "",
    suggestion: ""
  };

  const [formData, setFormData] = useState(initialForm);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const submitForm = async (e) => {
    e.preventDefault();

    if (!formData.full_name.trim() || !formData.phone_number.trim()) {
      toast.error("Please fill in all the fields.");
      return;
    }

    try {
      const response = await axios.post(
        "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/add_feedback",
        formData,
        {
          headers: { "Content-Type": "application/json" },
        }
      );


      if (response.data.success === 1 || response.data.success === "1") {
        toast.success(response.data.message ||  "Message submitted successfully!");

        setFormData(initialForm); 
      } else {
        toast.error("Submission failed!");
      }
    } catch (error) {
      console.error("Submission error:", error);
      toast.error("Something went wrong!");
    }
  };


  return (
    <div className="container feedback-section">
      <form onSubmit={submitForm} className="feedback-form">
        <div className="row">
          <h1 style={{fontSize:"35px", display:"flex", alignItems:"center", justifyContent:"center"}}>{t("hotel-feedback")}</h1>

          <div className="col-md-6 feedback-field">
            <label>{t("first-name")}:</label>
            <input
              type="text"
              name="full_name"
              placeholder={t("first-name")}
              value={formData.full_name}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-6 feedback-field">
            <label>{t("phone-no")}:</label>
            <input
              type="tel"
              name="phone_number"
              placeholder="(000) 000-0000"
              value={formData.phone_number}
              onChange={handleChange}
            />
          </div>

          <div className="col-12 feedback-field">
            <div className="rating-table-wrapper">
            <table className="rating-table">
              <thead>
                <tr>
                  <th>Category</th>
                  <th>Poor</th>
                  <th>Average</th>
                  <th>Good</th>
                  <th>Excellent</th>
                </tr>
              </thead>
              <tbody>
                {["reception", "room_cleanliness", "food_quality", "staff_behavior", "quality_service"].map((category) => (
                  <tr key={category}>
                    <td className="text-capitalize">{category.replace("_", " ")}</td>
                    {["Poor", "Average", "Good", "Excellent"].map((option) => (
                      <td key={option}>
                        <input
                          type="radio"
                          name={category}
                          value={option}
                          checked={formData[category] === option}
                          onChange={handleChange}
                        />
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
            </div>
          </div>

          <div className="col-12 feedback-field">
            <label>{t("suggestionsLabel")}</label>
            <textarea
              name="suggestion"
              rows="4"
              value={formData.suggestion}
              onChange={handleChange}
            ></textarea>
          </div>

          <div className="feedback-btn">
          <button type="submit">{t("submitButton")}</button>
        </div>
        </div>
      </form>
      <ToastContainer/>
    </div>
  );
};

export default Feedback;
